<!-- eslint-disable vue/multi-word-component-names -->
<script>
export default {
  props: {
    question: {
      type: String,
      default: '',
    },
    answer: {
      type: String,
      default: '',
    },
    answerClass: {
      type: String,
      default: '',
    },
    answerPostfix: {
      type: String,
      default: '',
    },
    answerPrefix: {
      type: String,
      default: '',
    },
    questionClass: {
      type: String,
      default: '',
    },
    between: {
      Type: Boolean,
      default: false,
    },
  },
};
</script>
<template>
  <div class="d-flex items-center" :class="{ 'justify-between': between, 'gap-2': !between }">
    <div :class="questionClass" class="fontFamilySET">{{ question }} :</div>
    <slot name="answer">
      <div class="answer flex-gap-1 fontFamilySET" :class="answerClass">
        <slot name="answerPrefix">
          <div class="fontFamilySET">
            {{ answerPrefix }}
          </div>
        </slot>
        <div class="fontFamilySET">
          {{ answer }}
        </div>
        <slot name="answerPostfix">
          <div class="fontFamilySET">
            {{ answerPostfix }}
          </div>
        </slot>
      </div>
    </slot>
  </div>
</template>
<style lang="scss">
.answer {
  font-weight: 600;
}
</style>
